module.exports = __webpack_public_path__ + "img/hero.50e0671b.jpg";